/**
 * Fail-over
 *
 * @since 2018-12-26
 * @author ms1124.kim
 */
let _failOverSocket = null
let _currentMmbrInfo = null

import {i18n} from '~/plugins/i18n'

/*
  이름: connectBackupDevice
  설명: Backup 장비에 연결할 때 호출한다.
*/
function connectBackupDevice (connUri) {
  // Promise 리턴
  return new Promise(function (resolve) {
    // 파라미터로 전달된 URI 접속
    const newConnWindow = window.open(connUri)

    // 윈도우가 종료되었는지 확인
    const checkCloseTimer = setInterval(() => {
      // 윈도우가 종료되었다면
      if (newConnWindow.closed) {
        // 타이머 객체 소멸
        clearInterval(checkCloseTimer)

        // 리턴값에 따라 resolve, reject 실행
        resolve()
      }
    }, 1000)
  })
}

/*
  이름: connectBackupDeviceSocket
  설명: Backup 장비 연결에 성공하면 해당 장비의 웹소켓으로 연결한다.
*/
function connectBackupDeviceSocket (targetIp, targetPort = 80, authToken = '') {
  // 주소창에 있는 프로토콜에 따라 접속 프로토콜 선택
  // const webSockProtocol = window.location.protocol.match(/https/) ? 'wss' : 'ws'
  const webSockProtocol = 'wss'

  // 웹소켓 주소 구성 - IPv4 / v6 구분
  const healthUri = `${webSockProtocol}://${targetIp.indexOf(':') > -1 ? `[${targetIp}]` : targetIp}:${webSockProtocol === 'wss' ? targetPort : 80}/ws/connect?token=${authToken}`

  // 웹소켓 생성
  _failOverSocket = new WebSocket(healthUri)

  // 웹소켓이 연결될 경우 이벤트 핸들러
  _failOverSocket.onopen = _onOpenBackupDeviceSocket

  // 서버에서 응답할 경우 이벤트 핸들러
  _failOverSocket.onmessage = _onMessageBackupDeviceInfo

  // 웹소켓이 끊어진 경우 이벤트 핸들러
  _failOverSocket.onclose = _onCloseBackupDeviceSock
}

/*
  이름: checkBackupDeviceMaster
  설명: Backup 장비로 웹소켓이 연결되면, 현재 Master
*/
function checkBackupDeviceMaster () {
  // 20초 타이머. 20초 안에 체크되지 못하면 reject
  let limitCount = 0

  // 장비 목록을 체크하는 타이머
  let checkMmbrTimer = null

  // Promise 리턴
  return new Promise(function (resolve, reject) {
    checkMmbrTimer = setInterval(function () {
      // 20초의 연결 대기시간이 지나면 아랫단계 진행
      if (limitCount === 20) {
        // 타이머 소멸
        clearInterval(checkMmbrTimer)

        // 소켓 제거
        _failOverSocket.close()

        // Reject 호출
        reject(new Error(i18n.t('msg.haFailover')))

        return false
      }

      // 연결 성공 시
      if (_currentMmbrInfo) {
        // 타이머 소멸
        clearInterval(checkMmbrTimer)

        // 소켓 제거
        _failOverSocket.close()

        // Resolve 호출
        resolve(_currentMmbrInfo.ha || [])

        return true
      }

      // 제한 타이머 증가
      limitCount += 1
    }, 1000)
  })
}

/*
  이름: _onOpenBackupDeviceSocket
  설명: 백업 장비로 소켓이 생성되었을 때 호출된다. 호출 시 백업 장비에게 정보를 요청한다.
*/
function _onOpenBackupDeviceSocket () {
  // 소켓 상태가 연결되었을 경우, 서버에 Ping 호출
  if (_failOverSocket.readyState === 1) {
    _failOverSocket.send({
      data: 'ping'
    })
  }
}

/*
  이름: _onMessageBackupDeviceInfo
  설명: 백업장비에서 요청에 대한 응답이 올 때 호출된다. 전달받은 Master 정보로 Redirect 한다.
*/
function _onMessageBackupDeviceInfo (backupData) {
  const backupFailOver = JSON.parse(backupData.data)

  // 웹소켓 데이터 저장
  _currentMmbrInfo = backupFailOver
}

/*
  이름: onCloseBackupDeviceSock
  설명: 소켓이 종료되면 호출된다. 실패하면, 다음 장비로 이동할 수 있도록 처리해야한다.
*/
function _onCloseBackupDeviceSock () {
  _failOverSocket = null
  _currentMmbrInfo = null
}

export {
  connectBackupDevice,
  checkBackupDeviceMaster,
  connectBackupDeviceSocket
}
